import { FC } from 'react';

import { ESHOP_TEST_ID } from '../../test/test-ids';
import {
    DescriptionSkeleton,
    ImageSkeleton,
    ProductCardSkeletonWrapper,
    TitleSkeleton,
} from './ProductCardSkeleton.styles';

export const classProductSkeleton = 'class-product-skeleton';

export const ProductCardSkeleton: FC = () => (
    <ProductCardSkeletonWrapper data-test={ESHOP_TEST_ID.PRODUCT_CARD_SKELETON} className={classProductSkeleton}>
        <ImageSkeleton />
        <TitleSkeleton />
        <DescriptionSkeleton />
    </ProductCardSkeletonWrapper>
);
